export const SubscriptionStatus = {
  Subscribed: "subscribed",
  Unsubscribed: "unsubscribed",
  Unknown: "unknown",
};
